package org.gymly.ui.admin

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.gymly.theme.AdminColors

@Composable
fun SettingsModuleToggleRow(
    label: String,
    checked: Boolean,
    enabled: Boolean,
    onCheckedChange: (Boolean) -> Unit,
) {
    Row(
        Modifier
            .fillMaxWidth()
            .padding(vertical = 4.dp),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Checkbox(
            checked = checked,
            onCheckedChange = onCheckedChange,
            enabled = enabled,
            colors = CheckboxDefaults.colors(
                checkedColor = AdminColors.Primary,
                checkmarkColor = AdminColors.OnBrand,
            ),
        )
        Text(label, color = AdminColors.Text, fontSize = 14.sp)
    }
}

@Composable
fun SettingsModuleEnableCard(
    title: String,
    description: String,
    enabledLabel: String,
    checked: Boolean,
    saving: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(14.dp))
            .background(AdminColors.Surface)
            .padding(16.dp),
    ) {
        Text(title, fontWeight = FontWeight.SemiBold, fontSize = 15.sp, color = AdminColors.Text)
        Text(description, color = AdminColors.TextMuted, fontSize = 13.sp, modifier = Modifier.padding(top = 4.dp, bottom = 10.dp))
        SettingsModuleToggleRow(
            label = enabledLabel,
            checked = checked,
            enabled = !saving,
            onCheckedChange = onCheckedChange,
        )
        if (!checked) {
            Spacer(Modifier.height(6.dp))
            Text(
                "Módulo desactivado: no se usa en cobros, reportes ni en el panel principal.",
                color = AdminColors.TextMuted,
                fontSize = 12.sp,
            )
        }
    }
}
